import React,{useState, useEffect} from 'react';
import Sides from '../Bars/Javasidebar';
import Button from 'react-bootstrap/Button'
import { Helmet } from "react-helmet";
function Jcontrol(){

    const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }

  
  
return(
    <div>

 
<Sides/>
<Helmet>
 
 <title>Master the Art of Java control structures: A Beginner's Tutorial Guide by CodeExampler</title>
<meta name="description" content="Get a grip on control structures in java with CodeExampler's comprehensive beginner's guide. From loops to conditionals, our tutorial provides clear examples and explanations to help you code like a pro." />
<meta name="keywords" content="Jcontrol structures in java, loops in Java, conditionals in Java,control structures in java with examples,decision control structure in java, CodeExampler" />
<link rel="canonical" href="https://www.codeexampler.com/java-control-structure" />
</Helmet>

<div className='lg:pl-56'>

    <h1 className="m-4 mh1">Control structure statement in Java<br/></h1>
    <div className="first">
        <a href="/java-first-program">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/java-if">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
    <p className="mt-4 para">The program is executed according to requirements. The sequence can be changed using the control structure statement. The categories and keywords are given below:
</p>
    
<h2 className="mt-4 mh2">The conditional statement is many types in Java:<br/></h2>

<h3 className="mt-4 mh3">If-condition <br/>
If-else<br/>
If-else-if<br/>
Nested if<br/>
Switch-case
</h3>
<h2 className="mt-4 mh2">Java looping (iteration)<br/></h2>
<h3 className="mt-4 mh3"> There are three types of looping in Java:<br/>
</h3>
<h4 className="mt-4 ">While loop<br/>
Do-while loop<br/>
For loop<br/>
</h4>
<h2 className="mt-4 mh2">Jumping statements in Java:<br/></h2>
<h3 className="mt-4 mh3">Java supports only three types of jumping statements in Java: 
<br/></h3>
<h4 className="mt-4 ">Break<br/>
Continue<br/>
return<br/>
</h4>

  <h1 className="mt-5">  </h1>
     
  <div className="back">
        <a href="/java-first-program">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/java-if">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
        </div>
    </div>
)

}
export default Jcontrol;